import styled from 'styled-components';
import {device} from '../../../../../utils/device';

export const FileInput = styled.div`
    width: ${p => (p.width ? `${p.width}px` : '236px')};
    height: ${p => (p.height ? `${p.height}px` : '42px')};
    position: relative;
    input[type="file"]{        
        width: 100%;
        height: 100%;
        outline: 0;
        cursor: pointer;
    }
    &::after{
        content: "";
        width: 100%;
        height: 100%;
        background: #EDF7FF;
        border: 1px dashed #6BB6F2;
        border-radius: 2px;
        position: absolute;
        left: 0;
        top: 0;
        pointer-events: none;
    }
    ${p =>
      p.textOnly &&
      `
        &::after{
            border: 0;
        }
    `}
    ${p =>
      p.bgColor &&
      `
        &::after{
            background: ${p.bgColor};
        }
    `}
    @media ${device.mobileS} {
        width: 100%;
    }
`;
export const Content = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
  z-index: 1;
  text-align: center;
  cursor: pointer;
  pointer-events: none;
  .makeFlex {
    display: flex;
  }
  .makeFlex .hrtlCenter {
    align-items: center;
  }
`;

export const UploadAgain = styled.p``;
